import { BarChartData, MultiBarChartData } from '../../types';

export const getBarChartMaxValue = (data: BarChartData | MultiBarChartData): number => {
  return Math.max(
    ...data.map((d) => {
      if (typeof d.value === 'object') {
        const values = Object.values(d.value)
          .map(Number)
          .filter((n) => !Number.isNaN(n));

        return values.length > 0 ? Math.max(...values) : 0;
      }

      return Number.isNaN(Number(d.value)) ? 0 : Number(d.value);
    }),
    1, // Ensure non-zero domain
  );
};

export const getBarChartTotalValue = (data: BarChartData | MultiBarChartData): number => {
  let totalValue = 0;
  for (const curr of data) {
    totalValue +=
      typeof curr.value === 'number'
        ? curr.value
        : Object.values(curr.value).reduce((sum, value) => sum + value, 0);
  }

  return totalValue;
};

export const getBarHeight = (
  innerHeight: number,
  value: number | { [key: string]: number },
  yScale: (value: number) => number,
) => {
  if (typeof value === 'object') {
    return Math.max(innerHeight - yScale(Math.max(...Object.values(value))), 2);
  }

  return Math.max(innerHeight - yScale(value), 2);
};
